import React, { useEffect, useState, useRef } from 'react';
import { PageHeader, Tabs, Table, Tag, Button, Typography, Divider, Radio } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

import * as IMI from '../../lib/ManiaFrameWork/js/mania';

const { TabPane } = Tabs;
const { Title, Paragraph } = Typography;

const routes = [
  {
    path: '/',
    breadcrumbName: 'Display',
  },
  {
    path: 'Calendar',
    breadcrumbName: 'Calendar',
  },
];

const Calendar_ = () => {

  useEffect(() => {
    new IMI.Calendar(document.getElementById('calendar'));
  }, []);


  return (
    <>
      <PageHeader title="Calendar" breadcrumb={{ routes }} subTitle="Calendar" style={{ padding: 10 }} />


      <div className="MF_area" >
        <div style={{ position:'relative', paddingBottom:250 }}>
          <input type="text"  id="calendar"/>
        </div>
      </div>

      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<input type="text"  id="calendar">`}
            </CodeHighlight>
          </TabPane>
          <TabPane tab="JAVASCRIPT" key="2">
            <CodeHighlight language="JS">
              {`new IMI.Calendar(document.getElementById('calendar'), {
  monthLimit:'today' || null,
});`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>
    </>
  );
}

export default Calendar_;
